<template>
  <el-container>
    <el-main>
      <span>{{ruleForm.id?'修改':'添加'}}导航</span>
      <el-button type="warning" size="mini" style="float: right" @click="returnBack">返回</el-button>
      <el-divider></el-divider>
      <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="导航标题" label-width="100px" prop="name">
          <el-input class="input" placeholder="请输入导航标题" maxlength="6" v-model="ruleForm.name"></el-input>
          <p style="color: #8c939d;font-size: 12px">最多输入6个字符</p>
        </el-form-item>
        <el-form-item label="上传图标" label-width="100px" prop="imgUrl">
          <el-upload
            class="avatar-uploader"
            :action="serverUrl"
            :show-file-list="false"
            :file-list="fileList"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar" alt="">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" label-width="100px" prop="priority">
          <el-input class="input" placeholder="请输入排序" v-model="ruleForm.priority"></el-input>
        </el-form-item>
        <el-form-item style="margin-left: -30%;text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import {saveArticle, updateArticle} from "../../../../api/system/articleSettings";
import {mapGetters} from "vuex";
import {getCompanyByAdmin} from "../../../../api/system/org-storage";

export default {
  name: "index",
  data() {
    return {
      ruleForm:{
        id:'',
        name:'',
        imgUrl:'',
        url:'',
        status:'1',//启用 2禁用
        priority:''
      },
      companyId:'',
      rules: {
        name: [
          { required: true, message: '请输入Banner标题', trigger: 'blur' },
        ],
        imgUrl: [
          { required: true, message: '请上传图标', trigger: 'blur' },
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      },
      id:'',
      fileList:[],
      serverUrl: 'https://wellhope.godaji.com/api/osp/articleSettings/image/upload',  // 这里写你要上传的图片服务器地址
      loading:false
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getCompanyByAdmin()
    if(this.$route.params.navList != null){
      this.ruleForm = JSON.parse(this.$route.params.navList)
    }
  },
  methods:{
    getCompanyByAdmin(){
      let param = {'id':this.currentUser.id}
      getCompanyByAdmin(param).then(res => {
        if(res.data.length > 0){
          this.companyId = res.data[0].id
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    handleAvatarSuccess(res, file) {
      console.log(res)
      this.ruleForm.imgUrl = res.data
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传图标只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图标大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {}
          param.name = this.ruleForm.name
          param.imgUrl = this.ruleForm.imgUrl
          param.url = this.ruleForm.url
          param.status = this.ruleForm.status
          param.priority = this.ruleForm.priority
          param.type = 1
          param.companyId = this.companyId
          if(this.ruleForm.id === ''){
            saveArticle(param).then(res => {
              // console.log(res)
              if(res.code === 200){
                this.loading = false
                this.$message.success('保存成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }else{
            param.id = this.ruleForm.id
            updateArticle(param).then(res => {
              // console.log(res);
              if(res.code === 200){
                this.loading = false
                this.$message.success('修改成功');
                this.returnBack()
              }
            }).catch(()=>{
              this.loading = false
              this.$message.error('添加失败，请重试');
            })
          }
        } else {
          // console.log('error submit!!');
          this.loading = false
          this.$message.error('添加失败，请重试');
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    returnBack(){
      this.$router.push({path: "/settings/nav/list"});
    }
  }
}
</script>

<style scoped>
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader >>> .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
  .form{
    margin-left: 30%;
    margin-top: 20px;
  }
  .input{
    width: 480px;
  }
</style>
